import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
// Local files
import { fillFlowsActions } from 'features/fillFlows';

const useFillFlows = () => {
  const dispatch = useDispatch();
  const getFillFlow = useCallback(() => dispatch(fillFlowsActions.getFillFlow()), [dispatch]);
  const createFillFlow = useCallback((fill_flow) => dispatch(fillFlowsActions.createFillFlow(fill_flow)), [dispatch]);
  const updateFillFlow = useCallback(fill_flow => dispatch(fillFlowsActions.updateFillFlow(fill_flow)), [dispatch]);
  const deleteFillFlow = useCallback(() => dispatch(fillFlowsActions.deleteFillFlow()), [dispatch]);
  const clearLocalActiveFillFlow = useCallback(() => dispatch(fillFlowsActions.clearLocalActiveFillFlow()), [dispatch]);

  return {
    getFillFlow,
    createFillFlow,
    updateFillFlow,
    deleteFillFlow,
    clearLocalActiveFillFlow
  };
};

export default useFillFlows;